import React from 'react';
import PropTypes from 'prop-types';
import {Button, Message, Icon, getMessage} from 'epic-diesel-common';
import Tip from '../../common/Tip';
import BenefitsSection from './BenefitsSections';
import styles from './HomeHeaderSection.pcss';
import {priority, sizes, svgs} from 'epic-diesel-common/src/constants';

export default class HomeHeaderSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        sectionData: PropTypes.object,
        affiliateAccount: PropTypes.object,
        isLoggedIn: PropTypes.bool
    };
    static defaultProps = {
        sectionData: {}
    };

    render() {
        const {sectionData, affiliateAccount, isLoggedIn, messages} = this.props;
        const title = sectionData.title || '';
        const warningText = sectionData.warningText || '';
        const {backgroundImage, description, benefitsSection} = sectionData;
        const style = {};
        const {verificationCode} = affiliateAccount || {};
        const signupSuccessText = getMessage(messages, 'epic.affiliate.signup.success.text');
        let button = <span />;
        let warning = <span />;

        const tip = (
            <Tip
                className={styles.tip}
                content={<span dangerouslySetInnerHTML={{__html: signupSuccessText}} />}
                position="left">
                <Icon icon={svgs.INFO} size={sizes.XSMALL} />
            </Tip>
        );

        if (isLoggedIn) {
            const affiliateStatus = affiliateAccount ? affiliateAccount.status : '';

            switch (affiliateStatus) {
                case 'ACTIVE':
                    break;

                case 'DISABLED':
                case 'DELETED':
                    button = (
                        <div className={styles.partnerButton}>
                            <Button className={styles.noAction} disabled={true} theme="dark">
                                <div>
                                    <Message code="epic.affiliate.common.advocateDisabled" />
                                </div>
                            </Button>
                        </div>
                    );
                    break;
                case 'REJECTED':
                case 'PENDING':
                    button = (
                        <div className={styles.partnerButton}>
                            <Button
                                className={styles.noAction}
                                priority={priority.PRIMARY}
                                disabled={true}
                                theme="dark">
                                {!verificationCode && (
                                    <div>
                                        <Message code="epic.affiliate.common.applicationSent" />
                                    </div>
                                )}
                                {verificationCode && (
                                    <Message
                                        code="epic.affiliate.common.yourCode"
                                        args={[verificationCode]}
                                    />
                                )}
                            </Button>
                            {verificationCode && tip}
                        </div>
                    );
                    break;

                case 'INIT':
                default:
                    break;
            }

            if (affiliateStatus !== 'ACTIVE') {
                warning = (
                    <div className={styles.statusBar}>
                        <p dangerouslySetInnerHTML={{__html: warningText}} />
                    </div>
                );
            }
        } else {
            warning = (
                <div className={styles.statusBar}>
                    <p dangerouslySetInnerHTML={{__html: warningText}} />
                </div>
            );
        }

        if (backgroundImage) {
            const url = `url("${backgroundImage}")`;
            style.backgroundImage = url;
        }
        return (
            <div className={styles.container} style={style}>
                <div className={styles.content}>
                    {warning}

                    <div className={styles.section}>
                        <h2 dangerouslySetInnerHTML={{__html: title}} />
                        <p dangerouslySetInnerHTML={{__html: description}} />
                    </div>
                    <BenefitsSection sectionData={benefitsSection} />

                    {button}
                </div>
            </div>
        );
    }
}
